import { FfNgxRequestBundleConfig } from "@fagforbundet/ngx-components";

export const requestBundleConfig: FfNgxRequestBundleConfig = {
  debug: false,
};
